<template>
  <Loader v-if="loader" />
  <div class="card ogo-rid">
    <div class="grid mt-4">
      <div class="col-12 lg:col-3">
        <div class="wrap">
          <h6 class="ml-2">Banca</h6>
          <MultiSelect v-model="selectedBank" :options="banks" optionLabel="name" optionValue="id" placeholder="Seleziona banca" class="inputfield w-full mt-2" />
        </div>
        <div v-show="validationErrors.bank && submitted" class="p-error">Seleziona campo.</div>
      </div>
      
      <div class="col-12 lg:col-3">
        <div class="wrap">
          <h6 class="ml-2">Tipo Rid</h6>
          <Dropdown v-model="typeSdd" :options="tipoRidOptions" optionLabel="label" optionValue="value" placeholder="Seleziona Tipo Rid" class="inputfield w-full mt-2" />
        </div>
        <div v-show="validationErrors.typeSdd && submitted" class="p-error">Seleziona campo.</div>
      </div>

      <div class="col-12 lg:col-4">
        <div class="wrap">
          <h6 class="ml-2">Tipo Data</h6>
          <Dropdown v-model="typeDate" :options="tipoDataOptions" optionLabel="label" optionValue="value" placeholder="Seleziona Tipo Data" class="inputfield w-full mt-2" />
        </div>
        <div v-show="validationErrors.typeDate && submitted" class="p-error">Seleziona campo.</div>
      </div>

      <div class="field col-12 lg:col-2">
        <div class="wrap pb-2">
          <h6>Anno</h6>
          <Calendar v-model="selectedYear" :showIcon="true" view="year" dateFormat="yy" class="inputfield w-full mt-2" />
        </div>
        <div v-show="validationErrors.selectedYear && submitted" class="p-error">Seleziona campo.</div>
      </div>
      <div class="col-12 flex justify-content-center align-items-center">
        <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" />
      </div>
    </div>
  </div>
  
  <div class="card riepilogo-rid" v-if="summaryRids">
    <h3 class="mb-5">Riepilogo</h3>
    <InputText @keyup="onGlobalSearch" class="mb-5 w-5" v-model="searchString" type="text" placeholder="Cerca per numero fattura ..." />
    <div v-if="Object.entries(summaryRids).length !== 0">
      <Accordion>
        <AccordionTab v-for="(elements, month) in summaryRids" :key="month">
          <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
              <div class="flex align-items-center">
                <i class="pi pi-calendar mx-2"></i>
                <span>{{ month }}</span>
              </div>
              <div class="text-left flex justify-content-between">
                <div v-if="daySelected != null && daySelected[month].length" class="mr-3">
                  <span class="price">{{ formatCurrency(daySelectedTot[month]) }}</span><br>
                  <small class="text-500">{{ daySelected[month].length }} elementi selezionat{{ daySelected[month].length == 1 ? 'i' : 'o' }}</small>
                </div>
                <div>
                  <span class="price">{{ formatCurrency(elements.total) }}</span><br>
                  <small class="text-500">{{ originalSummaryRids[month].data.length }} elementi</small>
                </div>
              </div>
            </div>
          </template>

          <div class="grid">
            <div v-for="obj in elements.day_total" :key="obj" class="col-12 lg:col-4 xl:col-3 box" @click="injectRidsDay(obj, month)">
              <div class="card" :class="{ active: obj.selected }">
                <div class="flex justify-content-between mb-3">
                  <div>
                    <span class="block text-900 font-medium mb-3">{{ moment(obj.date).format('DD-MM-YYYY') }}</span>
                    <span class="text-500 num-rid">{{ obj.num }} element{{ obj.num == 1 ? 'o' : 'i' }}</span>
                  </div>
                  <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-calendar text-blue-500 text-xl"></i>
                  </div>
                </div>
                <span class="text-500">{{ formatCurrency(obj.tot) }}</span>
              </div>
            </div>
          </div>

          <DataTable :ref="`dt_rid_${month}`" :value="elements.data" :paginator="true" :rows="10" :filters="filters"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]" responsiveLayout="scroll"
            currentPageReportTemplate="{first} a {last} di {totalRecords}">
            <template #header>
              <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                  <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV(month)" class="p-button-secondary" />
                </div>
              </div>
            </template>
            <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
            </template>
            <Column field="numero" header="N. Fattura" :sortable="true"></Column>
            <Column field="fornitura" header="Fornitura" :sortable="true"></Column>
            <Column field="banca" header="Banca" :sortable="true"></Column>
            <Column field="disposizione_sdd" header="Disposizione" :sortable="true"></Column>
            <Column field="tipo_mandato" header="Mandato" :sortable="true"></Column>
            <Column field="cliente" header="Cliente" :sortable="true"></Column>
            <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
            <Column field="data_fatturazione" header="Data Competenza" :sortable="true">
              <template #body="{ data }">
                {{ moment(data.data_fatturazione).format('DD-MM-YYYY') }}     
              </template>
            </Column>
            <Column field="data_emissione" header="Data Emissione" :sortable="true">
              <template #body="{ data }">
                {{ moment(data.data_emissione).format('DD-MM-YYYY') }}     
              </template>
            </Column>
            <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
              <template #body="{ data }">
                {{ moment(data.data_scadenza).format('DD-MM-YYYY') }}     
              </template>
            </Column>
            <Column field="data" header="Data Ricezione" :sortable="true">
              <template #body="{ data }">
                {{ moment(data.data).format('DD-MM-YYYY') }}     
              </template>
            </Column>
            <Column field="data_notifica" header="Data Notifica" :sortable="true">
              <template #body="{ data }">
                {{ moment(data.data_notifica).format('DD-MM-YYYY') }}     
              </template>
            </Column>
            <Column field="value" header="Importo" :sortable="true"></Column>
            <Column field="pagato" header="Pagato" :sortable="true"></Column>
            <Column field="importo_contabile" header="Contabile" :sortable="true"></Column>
            <Column field="agente" header="Agente" :sortable="true"></Column>
            <Column field="note" header="Note" :sortable="true"></Column>
          </DataTable>

        </AccordionTab>
      </Accordion>
    </div>
    <div v-else class="text-center">
      <div class="grid">
        <div class="xl:col-3 mx-auto">
          <img class="w-full" src="@/assets/img/no-data.svg" />
          <h6>Nessun dato</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    setup() {
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const loader = ref(false);
    const typeSdd = ref();
    const typeDate = ref();
    const selectedYear = ref();
    const selectedMonth = ref();
    const days = ref([]);
    const banks = ref([]);
    const selectedBank = ref();
    const summaryRids = ref();
    const originalSummaryRids = ref();
    const daySelected = ref();
    const daySelectedTot = ref();
    const searchString = ref('');
    const validationErrors = ref({});
    const submitted = ref(false);

    const tipoRidOptions = ref([
      { label: 'Storni', value: 'storno' },
      { label: 'Addebiti', value: 'addebito' }
    ]);

    const tipoDataOptions = ref([
      { label: 'Data Competenza', value: 'data_fatturazione' },
      { label: 'Data Emissione', value: 'data_emissione' },
      { label: 'Data Scadenza', value: 'data_scadenza' },
      { label: 'Data Notifica', value: 'data_notifica' },
      { label: 'Data Ricezione', value: 'data_ricezione' }
    ]);


      onMounted(() => { 
        getBanksTypeRid()
        selectedYear.value = moment(new Date).format('YYYY')    
      })


      const searchData = () => {
        searchString.value = ''
        submitted.value = true;
        // daySelected.value = []
        if (validateData()) {
          summaryRids.value = []
          selectedYear.value = moment(selectedYear.value).format('YYYY') 
          loader.value = true
          service.getSummaryRidsMonth(
            selectedBank.value,
            typeSdd.value,
            typeDate.value,
            selectedYear.value,
          ).then((res) => {
            summaryRids.value = res.items
            creteDayArray(summaryRids.value)
            creteBoxDate(summaryRids.value)
            // console.log(summaryRids.value)
          }).finally(() => {
              loader.value = false
          })
        }
      }

      const creteDayArray = (items) => {
        let obj = {}
        let obj_tot = {}
        for (const  [month] of Object.entries(items)) {
          obj[month] = []
          obj_tot[month] = 0
        }

        daySelected.value = obj
        daySelectedTot.value = obj_tot
      }

      const creteBoxDate = (items) => {
        let m = {}

        for (const  [month, item] of Object.entries(items)) {
              
              let days = []
              
              for(let el of item.data){
                if (typeDate.value) {
                  const normalizedDay = moment(el[typeDate.value]).format('YYYY-MM-DD');
                  if (!days.includes(normalizedDay)) {
                    days.push(normalizedDay);
                  }
                } 
              }

              days = days.sort()
              
              let obj = []
              days.forEach(day => {
                let d = {}
                d.date = day
                d.selected = false
                if (typeDate.value) {
                  d.tot = items[month].data
                    .filter(k => moment(k[typeDate.value]).format('YYYY-MM-DD') == day)
                    .reduce((acc, curr) => acc + curr.value, 0)
                  d.num = items[month].data
                    .filter(k => moment(k[typeDate.value]).format('YYYY-MM-DD') == day)
                    .length
                } 

                obj.push(d)
              });
              m[month] = obj
              items[month].day_total = m[month]
        }

        // create data copy not reactive
        originalSummaryRids.value = JSON.parse(JSON.stringify(summaryRids.value));

      }



      const getBanksTypeRid = () => {
        loader.value = true
        service.getBanksTypeRid().then((res) => {
          banks.value = res.items
        }).finally(()=>{
          loader.value = false
        })
      }


      const onGlobalSearch = () => {

        summaryRids.value = {...originalSummaryRids.value}
        filters.value.global.value = searchString.value

        if (searchString.value.length > 0) {
          for (const [month, rids] of Object.entries(originalSummaryRids.value)) {
            let obj ;
            obj = rids.data.filter(el => el.numero.includes(searchString.value.toUpperCase()))
            if (obj.length == 0) {
              delete summaryRids.value[month]
            }
          }
        }
      }

      const injectRidsDay = (obj, month) => {

        if (!daySelected.value[month].includes(obj.date)) {
          daySelected.value[month].push(obj.date)
        } else {
          daySelected.value[month] = daySelected.value[month].filter(el => el != obj.date)
        }

        if (!daySelected.value[month].includes(obj.date)) {
          daySelectedTot.value[month] += obj.tot
        } else {
          daySelectedTot.value[month] -= obj.tot
        }


        if (obj.selected == true) {
          obj.selected = false
          if (daySelected.value[month].length > 0) {
            if (typeDate.value) {
              summaryRids.value[month].data = originalSummaryRids.value[month].data.filter(el => daySelected.value[month].includes(el[typeDate.value]))
            } 
          } else {
            summaryRids.value[month] = {... originalSummaryRids.value[month]}
          }
         
        } else {
          if (typeDate.value) {
            summaryRids.value[month].data = originalSummaryRids.value[month].data.filter(el => daySelected.value[month].includes(el[typeDate.value]))
          } 
          obj.selected = true
        }

      }      

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      const exportCSV = (month) => {
        self.refs[`dt_rid_${month}`].exportCSV()
      };
      

      const validateData = () =>{
        if (selectedBank.value == null)
          validationErrors.value['bank'] = true;
        else 
          delete validationErrors.value['bank'];

        if (typeSdd.value == null || typeSdd.value.length == 0)
          validationErrors.value['typeSdd'] = true;
        else 
          delete validationErrors.value['typeSdd'];

        if (typeDate.value == null || typeDate.value.length == 0)
          validationErrors.value['typeDate'] = true;
        else 
          delete validationErrors.value['typeDate'];

        //let year = moment(selectedYear.value)
        if (!selectedYear.value)
          validationErrors.value['selectedYear'] = true;
        else 
          delete validationErrors.value['selectedYear'];
    
        return !Object.keys(validationErrors.value).length;
      }



      return {
        tipoRidOptions,
        tipoDataOptions,
        typeSdd,
        typeDate,
        selectedYear,
        summaryRids,
        originalSummaryRids,
        loader,
        filters,
        selectedMonth,
        days,
        banks,
        selectedBank,
        searchData,
        formatCurrency,
        validationErrors,
        submitted,
        searchString,
        onGlobalSearch,
        injectRidsDay,
        exportCSV,
        moment,
        daySelected,
        daySelectedTot,
      }
  }
}
</script>

<style>
.p-datatable .p-datatable-thead > tr > th.th-venduto {
  background: bisque !important;
}
.p-datatable .p-datatable-thead > tr > th.th-acquistato {
  background: rgb(184, 225, 251) !important;
}

.p-datatable .p-datatable-thead > tr > th.col-venduto {
  background: bisque;
}
.p-datatable .p-datatable-tbody > tr > td.border-lt {
  border-left: 1px solid rgba(62, 62, 62, 0.251);
}
.p-datatable .p-datatable-tfoot > tr > td.td-footer {
 color: #0a8cf5 !important;
 font-size: 15px;
}
.wrap {
  padding: 10px;
}
.riepilogo-rid .p-tabview-title {
  font-size: 18px !important;
}
.riepilogo-rid  .p-tabview-nav-link {
  min-width: 90px;
}
.riepilogo-rid  .price {
  min-width: 130px;
  font-size: 18px;
  color: #0a8cf5;
}
.riepilogo-rid  img {
  max-width: 130px;
}
.riepilogo-rid .box .card{
  cursor: pointer;
  background-color: rgba(243, 243, 243, 0.50);
}
.riepilogo-rid .box .card:hover{
  background-color: rgba(251, 251, 251, 0.5);
}
.riepilogo-rid .num-rid {
  font-size: 12px;
}
.riepilogo-rid .box .active {
  background-color: white;
  border-bottom: 3px solid #0a8cf5;
}
</style>
